"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestPasswordlessLogin = void 0;

var _requester = require("./utils/requester");

var _enums = require("./enums");

var _builders = require("./builders");

var _schemas = require("./schemas");

const requestPasswordlessLogin = (0, _requester.requestHandler)(async (username, method = _enums.PASSWORDLESS_LOGIN_TYPES.email, requester = _requester.authRequester) => {
  const payload = await (0, _builders.buildRequestPasswordlessLoginPayload)(username, method);
  const response = await requester().post(_enums.AUTH_ENDPOINT.requestPasswordlessLogin, payload);
  return _schemas.passwordlessLoginSchema.validateSync(response.data);
});
exports.requestPasswordlessLogin = requestPasswordlessLogin;